/**
 * Campaign Tracker Types
 *
 * Types for UTM parameter tracking.
 * Part of BEC-20520: Campaign Tracker with Salesforce
 */

/**
 * UTM parameters stored in the campaign cookie.
 * All fields are strings; missing params are stored as empty strings.
 */
export interface CampaignData {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
}

/**
 * Countries/regions requiring OneTrust consent for performance cookies.
 *
 * Scope: EU/EEA + US + CH + UK
 * - EU Countries (GDPR): AT, BE, BG, HR, CY, CZ, DK, EE, FI, FR, DE, GR, HU, IE, IT, LV, LT, LU, MT, NL, PL, PT, RO, SK, SI, ES, SE
 * - EEA (non-EU): NO, IS, LI
 * - US (CCPA)
 * - CH (Switzerland - similar to GDPR)
 * - GB (UK GDPR)
 */
export const CONSENT_REQUIRED_COUNTRIES = new Set([
  // EU Countries (GDPR)
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  // EEA (non-EU, but GDPR applies via EEA Agreement)
  'NO',
  'IS',
  'LI',
  // Other regions requiring consent
  'US', // USA (CCPA)
  'CH', // Switzerland (similar to GDPR)
  'GB', // United Kingdom (UK GDPR)
]);
